import { MOM_ACTION, STATUS } from "../constant";

const initState = {
  data: null,
  decisionData: null
};
export default function mom(state = initState, action) {
  switch (action.type) {
    case MOM_ACTION.MOM_CREATE_START:
      return { ...state, momStatus: STATUS.LOADING };
    case MOM_ACTION.MOM_CREATE_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        momStatus: STATUS.SUCCESS
      };
    }
    case MOM_ACTION.MOM_CREATE_FAILURE:
      return { ...state, momStatus: STATUS.ERROR };

    case MOM_ACTION.MOM_DETAILS_START:
      return { ...state, momDetailsStatus: STATUS.LOADING, data: null };
    case MOM_ACTION.MOM_DETAILS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        momDetailsStatus: STATUS.SUCCESS
      };
    }
    case MOM_ACTION.MOM_DETAILS_FAILURE:
      return { ...state, momDetailsStatus: STATUS.ERROR };
    case MOM_ACTION.MOM_DETAILS_CLEAR: {
      return {
        ...state,
        data: null
      };
    }

    case MOM_ACTION.GET_MOMS_START:
      return { ...state, momsStatus: STATUS.LOADING };
    case MOM_ACTION.GET_MOMS_SUCCESS: {
      return {
        ...state,
        momData: action.payload,
        momsStatus: STATUS.SUCCESS
      };
    }
    case MOM_ACTION.GET_MOMS_FAILURE:
      return { ...state, momsStatus: STATUS.ERROR };

    case MOM_ACTION.UPDATE_MOM_START:
      return { ...state, momUpdateStatus: STATUS.LOADING };
    case MOM_ACTION.UPDATE_MOM_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        momUpdateStatus: STATUS.SUCCESS
      };
    }
    case MOM_ACTION.UPDATE_MOM_FAILURE:
      return { ...state, momUpdateStatus: STATUS.ERROR };

    case MOM_ACTION.ADD_DECISION_START:
      return { ...state, decisionStatus: STATUS.LOADING };
    case MOM_ACTION.ADD_DECISION_SUCCESS: {
      return {
        ...state,
        decisionData: action.payload,
        decisionStatus: STATUS.SUCCESS
      };
    }
    case MOM_ACTION.ADD_DECISION_FAILURE:
      return { ...state, decisionStatus: STATUS.ERROR };
    case MOM_ACTION.SEND_MEETING_REMINDER_START:
      return { ...state, sendMeetingReminder: STATUS.LOADING };
    case MOM_ACTION.SEND_MEETING_REMINDER_SUCCESS:
      return { ...state, sendMeetingReminder: STATUS.SUCCESS };
    case MOM_ACTION.SEND_MEETING_REMINDER_FAILURE:
      return { ...state, sendMeetingReminder: STATUS.ERROR };

    case MOM_ACTION.GET_AGENDA_SUMMARY_START:
      return { ...state, agendaSummaryStatus: STATUS.LOADING };
    case MOM_ACTION.GET_AGENDA_SUMMARY_SUCCESS: {
      return {
        ...state,
        agendaSummaryData: action.payload,
        agendaSummaryStatus: STATUS.SUCCESS
      };
    }
    case MOM_ACTION.GET_AGENDA_SUMMARY_FAILURE:
      return { ...state, agendaSummaryStatus: STATUS.ERROR };
    default:
      return state;
  }
}
